import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.boundChange = this.toggleRowClass.bind(this)
    this.element.addEventListener("change", this.boundChange)
  }

  disconnect() {
    this.element.removeEventListener("change", this.boundChange)
  }

  toggleRowClass(event) {
    const input = event.target
    if (input.type !== "checkbox" || !input.name.startsWith("benefit_hidden[")) return

    const row = input.closest("tr")
    if (!row) return

    if (input.checked) {
      row.classList.add("table-secondary")
    } else {
      row.classList.remove("table-secondary")
    }
  }
}
